var m = require('mithril');
var formGroup = require('../formGroup');
var pikaday = require('../../libs/pikaday');

var component = {};

component.view = function view (vnode) {
  return m(formGroup, [
    m('label', {for: (vnode.attrs.field.id || 'number') + '-input'}, vnode.attrs.field.name),
    m(formGroup, [
      m(pikaday, {
        value: vnode.attrs.prop,
        dateFormat: 'm/d/Y h:i K',
        onchange: function (value) {
          if (typeof vnode.attrs.field.onchange === 'function') {
            vnode.attrs.field.onchange(value);
          }
        }
      })
    ])
  ])
};

module.exports = component;
